import React, { useState } from 'react'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'

import { ChevronDown, ChevronUp } from 'lucide-react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'

import RadioButton from 'images/inline/radio-button.svg'
import ActiveRadioButton from 'images/inline/radio-button-active.svg'

import Checkbox from 'images/inline/checkbox-dropdown.svg'
import ActiveCheckbox from 'images/inline/checkbox-dropdown-checked.svg'

import * as base from './DropdownSelect.module.scss'
import * as theme from './DropdownSelect-theme.module.scss'

let styles = {}
Object.assign(styles, base, theme)

// DropdownItems should look like this
// [{id: '', label:'', param: ''}]
// will return param on select

export const DropdownSelect = ({
  title,
  dropdownItems,
  onSelect,
  onDropdownOpen = null,
  menuID = 'null',
  singleSelect = true,
  clearSelect = null,
}) => {
  const [open, setOpen] = React.useState(false)
  const [activeSelects, setActiveSelects] = useState([])
  const anchorRef = React.useRef(null)

  const handleClick = (text = null) => {
    onSelect(text, title)
  }

  const handleToggle = (menuID, text) => {
    onDropdownOpen && onDropdownOpen(menuID, text)
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    setOpen(false)
  }

  const onDropDownItemClick = item => {
    if (singleSelect) {
      if (activeSelects.includes(item.id)) {
        setActiveSelects([])
        handleClick()
      } else {
        setActiveSelects([item.id])
        handleClick(item.param)
      }
    } else {
      var newSelect
      if (activeSelects.includes(item.id)) {
        newSelect = activeSelects.filter(i => i !== item.id)
        setActiveSelects(newSelect)
      } else {
        newSelect = [...activeSelects, item.id]
        setActiveSelects(newSelect)
      }
      handleClick(
        dropdownItems
          .filter(i => newSelect.includes(i.id))
          .map(i => i.param)
          .join(','),
      )
    }
  }

  return (
    <>
      <div>
        <ButtonGroup
          ref={anchorRef}
          aria-label="split button"
          className={styles.root}
        >
          <div
            onClick={event => {
              handleToggle(menuID, title)
            }}
            className={styles.title}
          >
            {title}
          </div>
          (
          <div
            className={styles.arrowDown}
            onClick={event => {
              handleToggle(menuID, title)
            }}
          >
            {open ? <ChevronUp color="white" /> : <ChevronDown color="white" />}
          </div>
          )
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={'list'}
          transition
          className="dropdown-popper"
          modifiers={[
            {
              name: 'flip',
              enabled: true,
              options: {
                allowedAutoPlacements: ['top', 'bottom'],
              },
            },
          ]}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList className={styles.list}>
                    {dropdownItems &&
                      dropdownItems.map((item, index) =>
                        item.noSelect ? (
                          <div key={index} className={styles.group}>{item.label}</div>
                        ) : (
                          <MenuItem
                            className={styles.menuItem}
                            key={index}
                            tabIndex={0}
                            onClick={event => {
                              onDropDownItemClick(item)
                            }}
                          >
                            {singleSelect ? (
                              <>
                                <div className={styles.singleSelect}>
                                  {activeSelects.includes(item.id) ? (
                                    <ActiveRadioButton />
                                  ) : (
                                    <RadioButton />
                                  )}
                                </div>
                                <div className={styles.dropdownCopy}>
                                  {item.label}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className={styles.multiSelect}>
                                  {activeSelects.includes(item.id) ? (
                                    <ActiveCheckbox width="18" />
                                  ) : (
                                    <Checkbox />
                                  )}
                                </div>
                                <div className={styles.dropdownCopy}>
                                  {item.label}
                                </div>
                              </>
                            )}
                          </MenuItem>
                        ),
                      )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </>
  )
}
